import { Link, useNavigate } from "react-router-dom";
import { ShoppingBag, Menu, X, User } from "lucide-react";
import { useState } from "react";
import { useCart } from "../context/CartContext";
import { useAuth } from "../context/AuthContext";

const links = [
  { to: "/", label: "Home" },
  { to: "/shop", label: "Shop" },
  { to: "/shop?collection=mobility", label: "Senior Care" },
  { to: "/about", label: "About" },
];

export const Navbar = () => {
  const { count } = useCart();
  const { user, logout } = useAuth();
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  return (
    <header className="sticky top-0 z-50 bg-white/80 backdrop-blur-xl border-b border-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <Link to="/" data-testid="nav-logo" className="flex items-center">
            <img src="/meow-care-logo-v2.png" alt="Meow Care Love" className="h-12 w-auto object-contain" />
          </Link>

          <nav className="hidden md:flex items-center gap-8">
            {links.map((l) => (
              <Link key={l.label} to={l.to} data-testid={`nav-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
                className="text-sm font-semibold text-[#0F0F0F] hover:text-[#FF5C28] transition-colors">
                {l.label}
              </Link>
            ))}
          </nav>

          <div className="flex items-center gap-3">
            {user && user !== false ? (
              <div className="hidden md:flex items-center gap-2">
                {user.role === "admin" && (
                  <Link to="/admin" data-testid="nav-admin" className="text-sm font-semibold hover:text-[#FF5C28]">Admin</Link>
                )}
                <Link to="/account" data-testid="nav-account" className="text-sm font-semibold hover:text-[#FF5C28]">My Account</Link>
                <button onClick={() => { logout(); navigate("/"); }} data-testid="nav-logout"
                  className="text-sm font-semibold text-gray-500 hover:text-[#FF5C28]">Logout</button>
              </div>
            ) : (
              <Link to="/login" data-testid="nav-login" className="hidden md:flex items-center gap-1.5 text-sm font-semibold hover:text-[#FF5C28]">
                <User className="w-4 h-4" strokeWidth={2.5} /> Login
              </Link>
            )}

            <Link to="/cart" data-testid="nav-cart" className="relative p-2.5 rounded-full bg-[#F8F9FA] hover:bg-gray-100 transition-colors">
              <ShoppingBag className="w-5 h-5" strokeWidth={2.5} />
              {count > 0 && (
                <span data-testid="cart-count" className="absolute -top-1 -right-1 bg-[#FF5C28] text-white text-xs font-bold w-5 h-5 rounded-full flex items-center justify-center">
                  {count}
                </span>
              )}
            </Link>

            <button onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle" className="md:hidden p-2.5 rounded-full bg-[#0F0F0F] text-white">
              {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
            </button>
          </div>
        </div>
      </div>

      {open && (
        <div className="md:hidden border-t border-gray-100 px-4 py-4 space-y-3 bg-white">
          {links.map((l) => (
            <Link key={l.label} to={l.to} onClick={() => setOpen(false)} className="block font-semibold py-1.5">{l.label}</Link>
          ))}
          {user && user !== false ? (
            <>
              {user.role === "admin" && <Link to="/admin" onClick={() => setOpen(false)} className="block font-semibold py-1.5">Admin</Link>}
              <Link to="/account" onClick={() => setOpen(false)} className="block font-semibold py-1.5">My Account</Link>
              <button onClick={() => { logout(); setOpen(false); navigate("/"); }} className="block font-semibold py-1.5 text-gray-500">Logout</button>
            </>
          ) : (
            <Link to="/login" onClick={() => setOpen(false)} className="block font-semibold py-1.5">Login</Link>
          )}
        </div>
      )}
    </header>
  );
};
